import { render, staticRenderFns } from "./GameSwitcher.vue?vue&type=template&id=3e1529b0"
import script from "./GameSwitcher.vue?vue&type=script&lang=js"
export * from "./GameSwitcher.vue?vue&type=script&lang=js"
import style0 from "./game-switcher.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports